export default {
    remove: 'Fjerne',
    save: 'Lagre',
    cancel: 'Avbryt',
    loading: 'Laster…',
    value: 'Verdi',
    'action-bar.collapse': 'Skjul',
    'action-bar.expand': 'Vis',
    'action-bar.actions': 'Handlinger',
    'callout.note': 'Note',
    'callout.important': 'Viktig',
    'callout.tip': 'Tip',
    'callout.caution': 'Advarsel',
    'callout.warning': 'Advarsel',
    'collapsible-section.open': 'Åpne { header } seksjon',
    'collapsible-section.close': 'Lukk { header } seksjon',
    'date-picker.today': 'I dag',
    'date-picker.month.heading': 'Måned',
    'date-picker.quarter.heading': 'Kvartal',
    'date-picker.year.heading': 'År',
    'chip-set.clear-all': 'Fjern alle',
    'file.drag-and-drop-tips':
        'Dra & slipp filen her, eller klikk for å bla gjennom.',
    'file-viewer.message.unsupported-filetype':
        'Kan ikke vise en forhåndsvisning av denne filtypen.',
    'file-viewer.message.try-other-options':
        'Last ned filen eller åpne den i en ny fane.',
    'file-viewer.download': 'Nedlasting',
    'file-viewer.exit-fullscreen': 'Gå ut av fullskjerm',
    'file-viewer.open-in-fullscreen': 'Åpne i fullskjerm',
    'file-viewer.open-in-new-tab': 'Åpne i en ny fane',
    'file-viewer.more-actions': 'Mer…',
    'editor-menu.bold': 'Fet',
    'editor-menu.italic': 'Kursiv',
    'editor-menu.strikethrough': 'Gjennomstreking',
    'editor-menu.h1': 'Overskrift 1',
    'editor-menu.h2': 'Overskrift 2',
    'editor-menu.h3': 'Overskrifts 3',
    'editor-menu.bulleted-list': 'Punktliste',
    'editor-menu.numbered-list': 'Nummerert liste',
    'editor-menu.blockquote': 'Blokksitat',
    'editor-menu.link': 'Legg til lenke',
    'editor-link-menu.text': 'Tekst',
    'editor-link-menu.link': 'Lenke',
    'editor-menu.code-block': 'Kodeblokk',
    'editor-menu.code': 'Kode',
    'editor-image-view.loading': 'Laster bilde: { filename }...',
    'editor-image-view.failed': 'Noe gikk galt med bildet: { filename }',
    'editor-image-view.success': 'Bilde: { filename } er klart',
    'editor-image-view.resize-handle':
        'Dra til høyre eller venstre for å endre størrelsen på bildet',
    'progress-bar': 'Fremdriftsindikator',
    'snackbar.dismiss': 'Lukk',
    'ai-avatar.label': 'KI-avatar',
    'ai-avatar.thinking': 'tenker',
    'table.select-all': 'Velg alle rader',
    'table.select-row': 'Velg denne raden',
    'profile-picture.remove': 'Fjern valgt bilde',
    'profile-picture.unsupported-preview.title': 'Ustøttet bildeformat',
    'profile-picture.unsupported-preview.description':
        'Vi kan ikke vise det valgte bildet i denne nettleseren. Vennligst velg en annen bildefil.',
};
